import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';

import { LoQueueService } from './loqueue';

export const Ng1LoQueueModule = angular
    .module('control-room.shared.services.loqueue', [])
    .factory('crLoQueueService',downgradeInjectable(LoQueueService));
